import { Component, Input, Output, EventEmitter, ChangeDetectorRef, OnChanges } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { fileValidator } from 'src/app/validators/file-validator';
import { fileCountValidator } from 'src/app/validators/file-count-validator';
import { fileSizeValidator } from 'src/app/validators/file-size-validator';

@Component({
  selector: 'app-opt-file-upload',
  templateUrl: './opt-file-upload.component.html',
  styleUrls: ['./opt-file-upload.component.scss']
})
export class OptFileUploadComponent implements OnChanges {
  @Input() myForm: FormGroup;
  @Output() newOptFile: EventEmitter<any> = new EventEmitter<any>();
  @Input() optDocs: File [] = [];
  private _optDoc;
  private _priorSize = window.navigator.msSaveOrOpenBlob ? undefined : 0;
  readonly MAX_ATTACHMENTS = 10; // Attachment count at which the Browse button is disabled

  constructor(private ref: ChangeDetectorRef) { }

  ngOnChanges() {
    this.ref.detectChanges();
  }

  public removeDoc(i) {
    this.optDocs.splice(i, 1);
  }

  // Disable the Browse button once the attachment limit is reached;
  // re-enabled automatically as soon as the count drops below the limit.
  public get isBrowseDisabled(): boolean {
    return this.optDocs.length >= this.MAX_ATTACHMENTS;
  }

  public fileChange(event, file?: HTMLInputElement): void {

      this.myForm.controls['optDoc'].setValidators( [
          fileCountValidator(this.optDocs.length), 
          fileValidator(), 
          fileSizeValidator(this.priorSize)
      ]);
      this.optDoc =  event.target.files ? event.target.files[0] : null;
      this.myForm.get('optDoc').setValue(this.optDoc, {emitModelToViewChange: false});

      if (this.myForm.controls['optDoc'].errors) {
        this.priorSize = 0;
        this.myForm.controls['optDoc'].updateValueAndValidity();

      } else {
          this.priorSize = this.optDoc ? this.optDoc.size : 0;
          this.optDoc ? this.optDocs.push(this.optDoc) : this.myForm.get('optDoc').setValue('');
          this.optDocs = this.optDocs.filter((doc, index, array) =>
                  index === array.findIndex((findDoc) =>
                      findDoc.name === doc.name
                  )
          );

        this.optDoc = null;
        this.myForm.get('optDoc').setValue('');
        this.newOptFile.emit(this.optDocs);
        this.myForm.controls['optDoc'].updateValueAndValidity();
      }

    }

    public get optDoc() {
      return this._optDoc;
    }
    public set optDoc(value) {
      this._optDoc = value;
    }
    public get priorSize() {
      return this._priorSize;
    }
    public set priorSize(value) {
      this._priorSize = value;
    }
}